<h3 class="text-uppercase">Premium vsebine</h3>
<p>Si želite <strong>boljšo izpostavljenost</strong> na strani ČakalneDobe.si in <strong>prepoznavnost vaše zdravstvene ustanove na spletu</strong>?
  Kliknite na spodnjo povezavo in izvedeli boste več o prednostih, ki jih nudi Premium profil.
</p>
<a [href]="premiumFlyerUrl" target="_blank" class="button button-3d button-amber m-0"><i class="la la-diamond"></i> Prednosti premium
  profila</a>
